export default __webpack_public_path__ + "static/media/SNAP_ PathToWork.059f482f.png";